var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1131 27.7185L16.125 24.1973V50.2167C16.1252 50.4994 16.1811 50.7792 16.2895 51.0403C16.3979 51.3013 16.5567 51.5385 16.7567 51.7382C16.9568 51.9379 17.1942 52.0963 17.4554 52.2042C17.7167 52.3122 17.9966 52.3676 18.2793 52.3674H52.7696C53.0526 52.3681 53.3329 52.313 53.5946 52.2053C53.8563 52.0975 54.0941 51.9392 54.2945 51.7395C54.495 51.5397 54.654 51.3024 54.7627 51.0411C54.8713 50.7798 54.9273 50.4997 54.9275 50.2167V40.6298L36.1131 27.7185Z",
    fill: "#185C37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1131 5.41748H18.2793C17.9966 5.41724 17.7167 5.47268 17.4554 5.58064C17.1942 5.68859 16.9568 5.84694 16.7567 6.04665C16.5567 6.24636 16.3979 6.48352 16.2895 6.74458C16.1811 7.00564 16.1252 7.28549 16.125 7.56816V17.155L36.1131 28.8926L46.6968 32.4139L54.9275 28.8926V17.155L36.1131 5.41748Z",
    fill: "#21A366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 17.1548H36.1131V28.8923H16.125V17.1548Z",
    fill: "#107C41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M30.4304 14.8071H16.125V44.151H30.4304C31.0004 44.1482 31.5463 43.9208 31.9499 43.5183C32.3535 43.1157 32.5822 42.5703 32.5865 42.0003V16.9578C32.5822 16.3878 32.3535 15.8424 31.9499 15.4399C31.5463 15.0373 31.0004 14.81 30.4304 14.8071Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.2548 15.981H16.125V45.3248H29.2548C29.8248 45.322 30.3708 45.0947 30.7744 44.6921C31.1779 44.2895 31.4066 43.7442 31.4109 43.1742V18.1316C31.4066 17.5616 31.1779 17.0162 30.7744 16.6137C30.3708 16.2111 29.8248 15.9838 29.2548 15.981Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.2548 15.981H16.125V42.9773H29.2548C29.8248 42.9745 30.3708 42.7472 30.7744 42.3446C31.1779 41.942 31.4066 41.3967 31.4109 40.8266V18.1316C31.4066 17.5616 31.1779 17.0162 30.7744 16.6137C30.3708 16.2111 29.8248 15.9838 29.2548 15.981Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M28.0792 15.981H16.125V42.9773H28.0792C28.6493 42.9745 29.1952 42.7472 29.5988 42.3446C30.0024 41.942 30.2311 41.3967 30.2353 40.8266V18.1316C30.2311 17.5616 30.0024 17.0162 29.5988 16.6137C29.1952 16.2111 28.6493 15.9838 28.0792 15.981Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52328 15.981H28.0806C28.6517 15.9805 29.1996 16.2067 29.6038 16.61C30.0081 17.0133 30.2358 17.5606 30.2367 18.1316V39.6529C30.2358 40.2239 30.0081 40.7712 29.6038 41.1745C29.1996 41.5778 28.6517 41.804 28.0806 41.8036H6.52328C6.24046 41.804 5.96032 41.7488 5.69887 41.6409C5.43742 41.5331 5.19979 41.3748 4.99955 41.175C4.79932 40.9753 4.6404 40.7381 4.5319 40.4769C4.42339 40.2157 4.36742 39.9357 4.36719 39.6529V18.1316C4.36742 17.8488 4.42339 17.5688 4.5319 17.3076C4.6404 17.0465 4.79932 16.8092 4.99955 16.6095C5.19979 16.4098 5.43742 16.2514 5.69887 16.1436C5.96032 16.0358 6.24046 15.9805 6.52328 15.981Z",
    fill: "url(#paint0_linear_91_7815)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0469 35.886L15.5812 28.8723L11.4279 21.8984H14.7632L17.0294 26.3641C17.2389 26.7867 17.3906 27.1009 17.4592 27.3103H17.4899C17.638 26.9709 17.7951 26.644 17.9594 26.3244L20.3827 21.9057H23.4526L19.1927 28.8398L23.5609 35.8914H20.2943L17.6759 30.9959C17.5543 30.7855 17.451 30.565 17.3671 30.3368H17.3238C17.2474 30.5591 17.1456 30.7718 17.0204 30.9707L14.3244 35.886H11.0469Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7755 5.41748H36.1172V17.155H54.9316V7.56816C54.9313 7.28534 54.8754 7.00534 54.7669 6.74416C54.6584 6.48298 54.4995 6.24575 54.2992 6.04602C54.099 5.84628 53.8613 5.68797 53.5999 5.58012C53.3384 5.47227 53.0583 5.41701 52.7755 5.41748Z",
    fill: "#33C481"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1172 28.8926H54.9316V40.6301H36.1172V28.8926Z",
    fill: "#107C41"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_91_7815",
    x1: 8.87079,
    y1: 14.2908,
    x2: 25.7331,
    y2: 43.4938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.5561f87ab318bb9ed1a6ca92bf7a806c.svg";
export { ForwardRef as ReactComponent };